import { RootState } from "../../rootState";

export const selectedFeaturesSelector = (state: RootState) => state.selectedFeatures?.features;

export const selectedFeaturesFromPortalSelector = (state: RootState) => state.selectedFeaturesFromPortal?.features;
